import React, { useEffect } from 'react';
import { AdminWSManager } from '@/hooks/useWebSocket';

const getAuthStatus = () => {
  try {
    const stored = localStorage.getItem('auth-storage');
    if (stored) {
      const data = JSON.parse(stored);
      if (data?.status === 'authenticated') return true;
      if (data?.state?.status === 'authenticated') return true;
      if (data?.token) return true;
    }
  } catch {}
  return false;
};

export const AdminWSProvider: React.FC<{ children?: React.ReactNode }> = ({ children }) => {
  useEffect(() => {
    const mgr = AdminWSManager.get();
    const shouldStart = getAuthStatus();
    if (shouldStart) mgr.start();

    // Listen for storage events to start/stop on login/logout
    const onStorage = (e: StorageEvent) => {
      if (e.key === 'auth-storage') {
        const auth = getAuthStatus();
        if (auth) mgr.start();
        else mgr.stop();
      }
    };

    window.addEventListener('storage', onStorage);

    return () => {
      window.removeEventListener('storage', onStorage);
      // don't force-stop on unmount; keep manager alive across route changes
    };
  }, []);

  return <>{children}</>;
};
